import React from 'react';
import BuildingAIKnowledge from '../containers/BuildingAIKnowledge';

export default (props) => (
  <BuildingAIKnowledge {...props} />
);
